module.exports = __webpack_public_path__ + "static/media/addBannar.0156f876.png";